import React from 'react';
import { FadeIn } from './FadeIn';
import { Mail, Linkedin, MapPin, Phone } from 'lucide-react';
export function Contact() {
  const items = [{
    icon: <Linkedin strokeWidth={1.5} size={24} data-id="element-36" />,
    label: 'LinkedIn',
    value: 'linkedin.com/in/sandy-gabriel-9b96233',
    href: 'https://www.linkedin.com/in/sandy-gabriel-9b96233/',
    external: true,
    color: '#00E5FF'
  }, {
    icon: <Mail strokeWidth={1.5} size={24} data-id="element-37" />,
    label: 'Email',
    value: 'sjgabriel74@yahoo.com',
    href: 'mailto:sjgabriel74@yahoo.com',
    color: '#7C3AED'
  }, {
    icon: <Phone strokeWidth={1.5} size={24} data-id="element-38" />,
    label: 'Phone',
    value: '(732) 319-6212',
    href: 'tel:+17323196212',
    color: '#E11D74'
  }, {
    icon: <MapPin strokeWidth={1.5} size={24} data-id="element-39" />,
    label: 'Location',
    value: 'Holmdel, NJ 07733, United States',
    color: '#C8A96A'
  }];
  return <section id="contact" className="relative py-24 md:py-32 bg-navy border-t border-white/5 overflow-hidden" data-id="element-40">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(0,229,255,0.5) 0%, transparent 70%)'
    }} data-id="element-41"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(225,29,116,0.5) 0%, transparent 70%)'
    }} data-id="element-42"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-43">
        <div className="relative rounded-3xl bg-white/[0.03] backdrop-blur-sm p-8 md:p-16 overflow-hidden" data-id="element-44">
          <div className="absolute inset-0 rounded-3xl pointer-events-none" style={{
          padding: '1px',
          background: 'linear-gradient(135deg, #00E5FF, #7C3AED, #E11D74, #C8A96A)',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude'
        }} data-id="element-45"></div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start relative" data-id="element-46">
            <div data-id="element-47">
              <FadeIn data-id="element-48">
                <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
                background: 'linear-gradient(90deg, #00E5FF, #E11D74)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-49">
                  Let's Connect
                </div>
                <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite leading-tight mb-8" data-id="element-50">
                  Open to{' '}
                  <span style={{
                  background: 'linear-gradient(135deg, #00E5FF, #7C3AED)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }} data-id="element-51">
                    board advisory
                  </span>{' '}
                  and strategic leadership opportunities.
                </h3>
                <p className="text-softwhite/65 font-light leading-relaxed mb-10 max-w-lg" data-id="element-52">
                  Reach out to discuss enterprise risk transformation,
                  regulatory governance, or executive advisory engagements.
                </p>
                <div className="w-20 h-px" style={{
                background: 'linear-gradient(90deg, #00E5FF, #E11D74)'
              }} data-id="element-53"></div>
              </FadeIn>
            </div>

            <div data-id="element-54">
              <FadeIn delay={0.2} data-id="element-55">
                <div className="space-y-3" data-id="element-56">
                  {items.map((item, i) => {
                  const content = <div className="group flex items-start space-x-5 p-5 border border-white/10 rounded-2xl hover:bg-white/[0.05] transition-all duration-300" onMouseEnter={e => {
                    ;
                    (e.currentTarget as HTMLElement).style.borderColor = `${item.color}80`;
                    (e.currentTarget as HTMLElement).style.boxShadow = `0 0 30px ${item.color}30`;
                  }} onMouseLeave={e => {
                    ;
                    (e.currentTarget as HTMLElement).style.borderColor = '';
                    (e.currentTarget as HTMLElement).style.boxShadow = '';
                  }} data-id="element-57">
                        <div className="mt-0.5 flex-shrink-0 transition-colors duration-300" style={{
                      color: item.color
                    }} data-id="element-58">
                          {item.icon}
                        </div>
                        <div className="min-w-0" data-id="element-59">
                          <div className="text-xs text-softwhite/50 uppercase tracking-widest mb-1" data-id="element-60">
                            {item.label}
                          </div>
                          <div className="text-base md:text-lg text-softwhite font-light transition-colors duration-300 break-all group-hover:text-white" data-id="element-61">
                            {item.value}
                          </div>
                        </div>
                      </div>;
                  if (item.href) {
                    return <a key={i} href={item.href} {...item.external ? {
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    } : {}} data-id="element-62">
                          {content}
                        </a>;
                  }
                  return <div key={i} data-id="element-63">{content}</div>;
                })}
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}